import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { areaData } from '@/utils/city';
/**
 * @description 验证手机号
 * @param value
 * @returns {boolean}
 */
export function isPhone(value) {
  const reg = /^1[3,4,5,6,7,8,9]\d{9}$/;
  return reg.test(value);
}
/**
 * 校验手机号和座机号
 * @param value
 * @returns {boolean}
 */
export function isTel(value) {
  const reg = /^(?:(?:\+86)?1[3-9]\d{9}|0\d{2,3}(?:-\d{7,8})?)$/;
  return reg.test(value);
}

/**
 * @description 校验密码
 * @param value
 * @returns {boolean}
 */
export function isPassWord(value) {
  const reg = /^[A-Za-z0-9]{8,}$/;
  return reg.test(value);
}

/**
 * @description 校验验证码格式
 * @param value
 * @returns {boolean}
 */
export function isCode(value) {
  const reg = /^\d{6}$/;
  return reg.test(value);
}
/**
 * @description 校验银行卡格式
 * @param {*} value
 * @returns
 */

export function isBankNo(value) {
  const reg = /^([1-9]{1})(\d{14}|\d{18})$/;
  return reg.test(value);
}
/**
 * @description 校验邮箱
 * @param {*} value
 * @returns
 */
export function checkEmail(email) {
  var regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!regEmail.test(email)) {
    return false;
  } else {
    return true;
  }
}
/**
 * @description 身份证获取信息
 * @param {*} idCard
 * @returns
 */
export function getCardInfo(idCard) {
  let sex = null;
  let birth = null;
  let myDate = new Date();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate();
  let age = 0;
  if (idCard.length === 18) {
    age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
    sex = idCard.substring(16, 17);
    birth = idCard.substring(6, 10) + '-' + idCard.substring(10, 12) + '-' + idCard.substring(12, 14);
    if (idCard.substring(10, 12) < month || idCard.substring(10, 12) === month && idCard.substring(12, 14) <= day) age++;
  }
  if (idCard.length === 15) {
    age = myDate.getFullYear() - idCard.substring(6, 8) - 1901;
    sex = idCard.substring(13, 14);
    birth = '19' + idCard.substring(6, 8) + '-' + idCard.substring(8, 10) + '-' + idCard.substring(10, 12);
    if (idCard.substring(8, 10) < month || idCard.substring(8, 10) === month && idCard.substring(10, 12) <= day) age++;
  }
  if (sex % 2 === 0) sex = 2;
  // 性别代码 1代表男，2代表女，暂时不涉及其他类型性别
  else sex = 1;
  return {
    age,
    sex,
    birth
  };
}
/**
 * @description base64解析图片
 * @param {*} file
 * @returns
 */
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
/**
 * 省份校验数据
 */
export const cityData = {
  11: '北京',
  12: '天津',
  13: '河北',
  14: '山西',
  15: '内蒙古',
  21: '辽宁',
  22: '吉林',
  23: '黑龙江 ',
  31: '上海',
  32: '江苏',
  33: '浙江',
  34: '安徽',
  35: '福建',
  36: '江西',
  37: '山东',
  41: '河南',
  42: '湖北 ',
  43: '湖南',
  44: '广东',
  45: '广西',
  46: '海南',
  50: '重庆',
  51: '四川',
  52: '贵州',
  53: '云南',
  54: '西藏 ',
  61: '陕西',
  62: '甘肃',
  63: '青海',
  64: '宁夏',
  65: '新疆',
  71: '台湾',
  81: '香港',
  82: '澳门',
  91: '国外 '
};
/**
 * @description 获取城市编码
 * @param {*} value
 * @returns
 */
export function getCityCode(value) {
  console.log(value, 22233);
  let cityValue = value.split(' ');
  let code = [];
  const province = areaData.filter(item => item.name == cityValue[0]);
  code.push(province[0].code);
  const city = province[0].children.filter(item => item.name == cityValue[1]);
  code.push(city[0].code);
  const area = city[0].children.filter(item => item.name == cityValue[2]);
  code.push(area[0].code);
  console.log(code, 111);
  return code;
}

/**
 * @description 校验身份证信息
 * @param {*} value
 * @returns
 */

export function isCardNo(idcard) {
  var pattern = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
  return pattern.test(idcard);
}
/**
 * @description 校验身份证信息
 * @param {*} value
 * @returns
 */

export function validateIdCardNo(idCard) {
  // 18位身份证正则表达式
  let regExp18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;

  // 15位身份证正则表达式
  let regExp15 = /^[1-9](\d{5})(\d{2})((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)(\d{3})$/;
  if (regExp18.test(idCard)) {
    // 校验18位身份证
    let weightedFactors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let checkCodeMap = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += parseInt(idCard.charAt(i), 10) * weightedFactors[i];
    }
    let mod = sum % 11;
    let checkCode = checkCodeMap[mod];
    return idCard.charAt(17).toUpperCase() === checkCode;
  } else if (regExp15.test(idCard)) {
    // 校验15位身份证
    return true; // 15位身份证不校验其他信息，只校验格式
  } else {
    return false;
  }
}